import React, { memo } from 'react'
import { InlineMessage, INLINE_MESSAGE_VARIANTS } from 'transfix-ui/components/InlineMessage'
import { Spinner } from 'transfix-ui/components/Spinner'
import { ILoadBoardPost } from 'types/loadBoardPosts'
import { PostListEntry } from './PostListEntry'

interface IPostListProps {
  posts: ILoadBoardPost[]
  loading: boolean
  error: string
  noPostMessage: string
}

const seperateEntries = (acc: JSX.Element[], val: JSX.Element) => {
  if (acc.length === 0) return [val]
  return [...acc, <hr className='mh0' />, val]
}

export const PostList = memo<IPostListProps>(({ error, loading, noPostMessage, posts }) => (
  <>
    {loading && <Spinner />}
    {posts.map(post => <PostListEntry post={post} />).reduce(seperateEntries, [])}
    {posts.length === 0 && !loading && !error && (
      <div className='text-secondary'>{noPostMessage}</div>
    )}
    {error && <InlineMessage type={INLINE_MESSAGE_VARIANTS.ALERT} message={error} />}
  </>
))
